module.exports = __webpack_public_path__ + "static/media/rightOrangeArrow.781d9366.svg";